<app-periodical-filters class="app-filters" [class.app-panel-mobile-hidden]="periodicalService.activeMobilePanel != 'filters'"></app-periodical-filters>

<app-periodical-content *ngIf="periodicalService.isStateSuccess()"></app-periodical-content>

<mat-spinner class="medium-centered-spinner"  *ngIf="periodicalService.isStateLoading()" [strokeWidth]="3" [diameter]="40"></mat-spinner>

<app-metadata [metadata]="periodicalService.metadata" [class.app-panel-mobile-hidden]="periodicalService.activeMobilePanel != 'metadata'"></app-metadata>
